
import React, { Component } from 'react';

import { connect } from '../../../base/redux';
import { getUnreadCount } from '../../functions';

/**
 * The type of the React {@code Component} props of {@link ChatCounter}.
 */
type Props = {

    /**
     * The value of to display as a count.
     */
    _count: number
};

/**
 * Implements a React {@link Component} which displays a count of the number of
 * unread chat messages.
 *
 * @augments Component
 */
class ChatCounter extends Component<Props> {

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const chatCount = this.props._nbUnreadMessages > this.props._count ? this.props._nbUnreadMessages : this.props._count;

        return chatCount > 0 && (
            <span className = 'badge-round'>
                <span>
                    { chatCount }
                </span>
            </span>
        );
    }
}

/**
 * Maps (parts of) the Redux state to the associated {@code ChatCounter}'s
 * props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _count: number
 * }}
 */
function _mapStateToProps(state) {
    const nbUnreadMessages = state['features/chat']?.nbUnreadMessages;

    return {
        _nbUnreadMessages: nbUnreadMessages,
        _count: getUnreadCount(state)

    };
}

export default connect(_mapStateToProps)(ChatCounter);
